export const KEYCODES = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  PAUSE_BREAK: 19,
  CAPS_LOCK: 20,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40,
  INSERT: 45,
  DELETE: 46,
  NUM_LOCK: 144,
  SCROLL_LOCK: 145,
};

export const CLASSES = {
  IS_ACTIVE: "is-active",
  IS_VISIBLE: "is-visible",
  IS_HIDDEN: "is-hidden",
  HIDDEN: "is-hidden",
  IS_FIXED: "is-fixed",
  FIXED: "is-fixed",
  IS_OPEN: "is-open",
  OPEN: "is-open",
  IS_SHOW: "is-show",
  IS_DISABLED: "is-disabled",
  ERROR: "has-error",
  IS_EDITABLE: "is-editable",
  LOADER: "loader",
  LOADER_WRAPPER: "loader-wrapper",
  FORM_INPUT: "form-control",
  FORM_CHECKBOX: "checkbox",
  FORM_SUBMIT: "form-submit",
  TOOLTIP_ACTIVE: "tooltipstered"
};
